import React from "react";
import { useAuth } from "./Auth/hooks/useAuth";
import { translate } from "../utils/translations/translate";
import { InfoModal } from "./UI/InfoModal";
export const PasswordResetConfirmation = ({ forEmail, onClose }) => {
  const { logoutUser } = useAuth();
  const confirmationMessage = translate(
    "labels.passwordUpdatedConfirmationMessage"
  ).replace("$email", forEmail);
  const secondaryMessage = translate("labels.passwordCloseModalInfo");
  return (
    <>
      <InfoModal
        onClose={() => {
          onClose();
          logoutUser();
        }}
        title={translate("labels.passwordUpdated")}
        primaryMessage={confirmationMessage}
        secondaryMessage={secondaryMessage}
        showActionButton={false}
        titleStyles={{ color: "green",fontWeight:"bold" }}
      />
    </>
  );
};
